import debug from 'debug'
import xhook from 'xhook'

export const enable = () => {
  xhook.enable()
  window.WebSocket = HookedWebSocket as any
}

const log = debug('proxy')

const exclude = function (request) {
  return /yandex\.ru|amplitude\.com|facebook\.com|sentry\.io|localhost|vk\.com/.test(request.url)
}

xhook.before(request => {
  if (request.url.indexOf('/') !== 0 && !exclude(request)) {
    log(`${request.method}:${request.url}`)
    const secure = request.url.indexOf('https') === 0
    request.url = `${secure ? 'https' : 'http'}://proxy.kidsout.ru/${encodeURIComponent(request.url)}`
  }
})

const OriginalWebSocket = window.WebSocket
const HookedWebSocket = function (url, ...params) {
  if (!exclude({ url })) {
    log(`WS:${url}`, ...params)
    const secure = url.indexOf('wss') === 0
    return new OriginalWebSocket(`${secure ? 'wss' : 'ws'}://proxy.kidsout.ru/${encodeURIComponent(url)}`, ...params)
  }
}
HookedWebSocket.prototype = OriginalWebSocket.prototype
